import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleArchiveService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /**
   * Firefly生成画像とメタデータをGoogle DriveとSheetsに保存
   * @param imageData Base64形式の画像データまたは画像URL
   * @param prompt 使用したプロンプト
   * @param parameters 使用したパラメータ
   */
  saveFireflyImage(
    imageData: string,
    prompt: string,
    parameters: any,
    generatedSeed?: number | string
  ): Observable<any> {
    // 画像がURLの場合はBase64に変換する必要がある
    const isDataUrl = imageData.startsWith('data:');
    let processedImageData = imageData;

    if (!isDataUrl) {
      // URLとして処理
      console.warn('画像データがBase64形式ではありません。URLとして処理します。');
    }

    const url = `${this.apiUrl}/google/save-firefly-image`;
    return this.http.post(url, {
      imageData: processedImageData,
      prompt,
      parameters,
      generatedSeed  // APIから返ってきた実際のシード値を渡す
    });
  }

  /**
   * Trading Card用の画像とメタデータをGoogle DriveとSheetsに保存
   * @param imageData 画像データ（URLまたはBase64）
   * @param prompt 背景プロンプト
   * @param parameters カード生成パラメータ
   * @param generatedSeed 生成時のシード値
   */
  saveTradingCard(
    imageData: string,
    prompt: string,
    parameters: any,
    generatedSeed?: number | string
  ): Observable<any> {
    const url = `${this.apiUrl}/google/save-trading-card`;
    return this.http.post(url, {
      imageData,
      prompt,
      parameters,
      generatedSeed
    });
  }
}